import axios, {
  AxiosPromise,
} from 'axios';
import {
  OsmosisLearnData,
  OsmosisTranscriptDto
} from './osmosis-service.dtos';
import { addSearchParams } from '../../utilities/app.utilities';

export const fetchOsmosisTranscript = (learnName: string, auth: string): AxiosPromise<OsmosisTranscriptDto> => {
  return axios.get(`https://www.osmosis.org/api/learn/transcripts?learnName=${encodeURIComponent(learnName)}&auth=${auth}`);
};

export const fetchOsmosisLearnData = (learnNodeID: string,): AxiosPromise<OsmosisLearnData> => {
  return axios.get(addSearchParams('https://www.osmosis.org/learnData', { learnNodeID }));
};
